/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * EXPORTS
 */
export default gql`
mutation EntityCreateMutation($input: [EntityCreateInput!]!) {
  EntityCreate(input: $input) {
    message
    status
  }
}
`
